
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kort",
      function () {
        return require("private-next-pages/kort/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kort"])
      });
    }
  